import React from 'react';
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import { FormFieldProp } from '../../../enum/apiResultProp/FormFieldProp';
import { EventType } from '../../../enum/EventType';
import { EventProp } from '../../../enum/apiResultProp/EventProp';
import { ActionType } from '../../../enum/ActionType';
import { ActionProp } from '../../../enum/apiResultProp/ActionProp';

export default ({ fieldProps, onValueChange, onActionMutateScreenWithPostData, tableFormRowKey, hasSpinner }) => {
    const boolSliderFields = fieldProps[FormFieldProp.BoolSliderFieldsList];

    return (
        _.map(boolSliderFields, (boolSliderField, key) => {
            const name = boolSliderField[FormFieldProp.Name];
            const value = boolSliderField[FormFieldProp.Value];
            const placeholder = boolSliderField[FormFieldProp.Placeholder];
            const showLabel = boolSliderField[FormFieldProp.ShowLabel];
            const label = boolSliderField[FormFieldProp.Label];
            const hasError = boolSliderField[FormFieldProp.HasError];
            const showMandatorySign = boolSliderField[FormFieldProp.ShowMandatorySign];
            const isReadOnly = boolSliderField[FormFieldProp.IsReadOnly];
            const events = boolSliderField[FormFieldProp.Events];

            const onChange = async () => {
                await onValueChange({ value: !value, boolSliderFieldIndex: key });

                if (events) {
                    _.forEach(events, (backEndEvent) => {
                        const eventType = backEndEvent[EventProp.EventType];

                        switch (eventType) {
                            case EventType.OnInputChange:
                                const action = backEndEvent[EventProp.Action];
                                const actionType = action[ActionProp.ActionType];

                                if (actionType === ActionType.MutateScreenWithPostDataAction) {
                                    const backEndUrl = action[ActionProp.BackEndUrl];

                                    onActionMutateScreenWithPostData({ backEndUrl: backEndUrl, rowKey: tableFormRowKey, hasSpinner: hasSpinner });
                                }
                                break;
                            default:
                                break;
                        }
                    });
                }
            };

            let boolFieldProps = {
                checked: value,
                slider: true,
                required: showMandatorySign,
                readOnly: isReadOnly,
                disabled: isReadOnly,
                error: hasError,
                placeholder: placeholder,
                onChange: (e) => onChange(),
                style: { paddingTop: '1em' },
            };
            if (showLabel) {
                boolFieldProps = { ...boolFieldProps, label: label };
            }

            return (
                <React.Fragment key={key}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Form.Checkbox {...boolFieldProps} />
                    </div>
                </React.Fragment>
            );
        })
    );
}
